import { mergeWith, isArray , get } from 'lodash';
import featureNames from '@utils/featureToggle/constants';

export const mergeObjectsWithSameKey = (obj1, obj2) => {
  return mergeWith({}, obj1, obj2, (value1, value2) => {
    if (isArray(value1) && isArray(value2)) {
      return value1.concat(value2);
    } else {
      return undefined;
    }
  });
};

export const checkIfStreamMetaAccountEnabled = () => {
  const state = window.store ? window.store.getState() : {};
  const features = get(state, 'common.features', {});
  return features[featureNames.STREAM_METADATA_ACCOUNT];
};

export const renameAllShortInAString = (data) => {
  if (!checkIfStreamMetaAccountEnabled()) return data;
  ['VPF', 'VRT', 'VSF', 'VST', 'EBVS'].forEach((short) => {
    data = data.replaceAll(short, renameShort(short));
  });
  return data;
};

export const renameVideoToStream = (data) => {
  if (!data) {
    return '';
  }
  if (!checkIfStreamMetaAccountEnabled()) return data;
  const processedData = JSON.stringify(data)
    .replaceAll('Video', 'Stream')
    .replaceAll('video', 'stream');
  return JSON.parse(processedData);
};

export const renameShort = (shortName) => {
  if (!checkIfStreamMetaAccountEnabled()) return shortName;
  const shortNames = {
    VPF: 'SPF',
    'VPF-B': 'SPF-B',
    'VPF-T': 'SPF-T',
    'VPF-T ADS': 'SPF-T ADS',
    VRT: 'SRT',
    VSF: 'SSF',
    'VSF-B': 'SSF-B',
    'VSF-T': 'SSF-T',
    VST: 'SST',
    EBVS: 'EBSS',
  };
  return shortNames[shortName] ? shortNames[shortName] : shortName;
};
